import React from 'react'
import style from '../../../css/homepage/Conditions.module.css'


const Disclaimer = () => {
    return (
        <div>
            <div className={`${style.containerfluid} container-fluid`}>
                <div className="container">
                    <div className={`${style.firstrow} row`}>
                        <h2>
                            Disclaimer
                        </h2>
                    </div>

                    <div className={`${style.secondrow} row`}>
                        <h6>
                            Welcome to <a href="">Swingalgo.com</a> (the "Website"). By accessing or using this Website, you acknowledge and agree to the following terms of this Disclaimer.
                        </h6>

                        <h6>
                            The information provided on <a href="">Swingalgo.com</a> is for general informational and educational purposes only. While we strive to ensure accuracy, we make no representations or warranties, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any content on this Website.
                        </h6>

                        <h6>
                            The content on this Website does not constitute financial, investment, or trading advice.
                        </h6>

                        <h6>
                            It is not intended as an offer to sell or a solicitation to buy any financial instruments.
                        </h6>

                        <h6>
                            You are solely responsible for making investment decisions and should consult a qualified financial advisor before investing.
                        </h6>

                        <h6>
                            Investing in securities markets carries risks, including the risk of partial or permanent loss.
                        </h6>

                        <h6>
                            Past performance is not indicative of future results.
                        </h6>

                        <h6>
                            Any securities or investment examples mentioned on this Website are for illustrative purposes only and are not recommendations.
                        </h6>

                        <h6>
                            The stock market is subject to fluctuations, and investments may lose value due to market conditions, economic factors, or unforeseen events.
                        </h6>

                        <h6>
                            <a href="">Swingalgo.com</a> and its team shall not be held liable for any loss or damage (direct or indirect) arising from the use of this Website or reliance on any information provided.
                        </h6>

                        <h6>
                            We are not responsible for any investment decisions, profits, or losses incurred by users based on the content on this Website.
                        </h6>

                        <h6>
                            This Website may contain links to third-party websites or content.
                        </h6>

                        <h6>
                            We do not endorse, control, or guarantee the accuracy, legality, or reliability of third-party content.
                        </h6>

                        <h6>
                            Users should review the terms and policies of any external websites they visit.
                        </h6>

                        <h6>
                            Any content shared on our social media platforms (including but not limited to Twitter, Instagram, Telegram, or YouTube) is for educational purposes only and should not be construed as investment advice.
                        </h6>

                        <h6>
                            Investors are strongly encouraged to consult their financial advisors before making investment decisions.
                        </h6>

                        <h6>
                            We reserve the right to modify or update this Disclaimer at any time without prior notice. Continued use of this Website after any modifications constitutes acceptance of the updated Disclaimer
                        </h6>


                    </div>

                    <div className={`${style.fourthrow} row`}>
                        <h3>
                            Disclosures & Risk Factors
                        </h3>
                    </div>

                    <div className={`${style.secondrow} row`}>
                        <h6>
                            Business Activity:
                            Swingalgo is engaged in the business of Research Analyst activities and Educational Services.
                        </h6>

                        <h6>
                            Disciplinary History:
                            There has been no instance of any disciplinary action, penalty, etc., levied/passed by any regulation/administrative agencies against Swingalgo and its partners.
                        </h6>

                        <h6>
                            Terms & Conditions of Issuance of Research Report:
                            The research report is issued to registered clients. It is based on facts, figures, and information considered true, correct, and reliable. The information contained herein is from publicly available data or other sources believed to be reliable. The report is prepared solely for informational purposes and does not constitute an offer document or solicitation to buy, sell, hold, or subscribe to securities or other financial instruments.
                        </h6>

                        <h6>
                            Risk Disclosures:

                            Swingalgo, its partners, employees, officers, and affiliates are not responsible for any loss or damage that may arise due to any error in the information presented in the research report. Investors may lose their entire investment or portfolio under certain market conditions. Investors should understand their risk appetite and consult financial advisers before acting on any recommendations.
                        </h6>

                        <h6>
                            The research report does not take into account any specific investment objective, financial situation, or individual needs. Investors should act according to their own risk appetite and financial position while understanding the risks involved in capital markets.
                        </h6>

                        <h2>
                            Disclosures Regarding Ownership & Material Conflicts of Interest:
                        </h2>

                        <h6>
                            Swingalgo or its research analysts, relatives, or associates have no direct or indirect financial interest in any subject company.
                        </h6>

                        <h6>
                            Swingalgo or its research analysts, relatives, or associates do not have any material conflict of interest at the time of publication of research reports.
                        </h6>

                        <h6>
                            Swingalgo or its research analysts, relatives, or associates do not have actual ownership of one percent or more securities of any subject company.
                        </h6>

                        <h2>Disclosures Regarding Receipt of Compensation:</h2>

                        <h6>
                            Swingalgo or its associates have not received any compensation from any subject company in the past twelve months.
                        </h6>

                        <h6>
                            Swingalgo or its associates have not managed or co-managed any public offering of securities for any subject company in the past twelve months.
                        </h6>

                        <h6>
                            Swingalgo or its associates have not received any compensation or other benefits from any subject company or third party in connection with research reports.
                        </h6>

                        <h2>Risk Factors Affecting Investments:</h2>

                        <h6>
                            1. Market Risk – Investments are subject to market fluctuations that may negatively impact returns.
                        </h6>

                        <h6>
                            2. Financial Risk – Changes in interest rates, exchange rates, or economic conditions can affect investments.
                        </h6>

                        <h6>
                            3. Operational Risk – Any disruptions in operations could lead to production delays and financial losses.
                        </h6>

                        <h6>
                            4. Regulatory Risk – Changes in regulations or legal actions can impact financial results.
                        </h6>

                        <h6>
                            5. Competition Risk – Market competition can lead to pricing pressures and reduced market share.
                        </h6>

                        <h6>
                            6. Technology Risk – Cybersecurity breaches or technological failures could affect data security and reputation.
                        </h6>

                        <h6>
                            7. Supply Chain Risk – Disruptions in supply chains can impact investment performance.
                        </h6>

                        <h6>
                            8. Environmental & Sustainability Risk – Environmental compliance and sustainability issues could impact businesses.
                        </h6>

                        <h6>
                            9. Credit Risk – Economic downturns or defaults by borrowers could lead to financial losses.
                        </h6>

                        <h6>
                            10. Litigation Risk – Ongoing or potential legal actions could result in financial liabilities.
                        </h6>

                        <h2>
                            Changes to Disclaimer
                        </h2>

                        <h6>
                            We reserve the right to modify or update this disclaimer at any time without notice. Your continued use of this Website constitutes your acceptance of any changes.
                        </h6>

                        <h6>
                            If you have any questions or concerns regarding this Disclaimer, please contact us at:
                            📧 Email: <a href="">support@Swingalgo.com</a>.
                        </h6>
                    </div>

                    <div className={`${style.thirdrow} row`}>
                        <h5>
                            Last Updated: <span className={style.updatedate}>May 1, 2025</span>
                        </h5>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Disclaimer